import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import payShiftService from './pay-shift.service';

export interface PayShiftState { }

const PayShiftStore: Module<PayShiftState, StoreState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async get({ commit }, { company_id }: { company_id: number }) {
            return await payShiftService.get({ company_id }).then((response) => response.data);
        },
    },
};

export default PayShiftStore;
